var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyBasket = function SvgEmptyBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 183,
    viewBox: "0 0 204 183",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.354%",
    y1: "28.475%",
    x2: "-1.78%",
    y2: "53.442%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC902",
    stopOpacity: 0.422,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD7CB",
    stopOpacity: 0.06,
    offset: "47.897%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-20.929%",
    y2: "65.357%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#538EB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1D7E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.248%",
    y1: "37.658%",
    x2: "0%",
    y2: "70.613%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E6EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.943%",
    y1: "12.618%",
    x2: ".24%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5E6",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.042%",
    y1: "-7.875%",
    x2: "9.958%",
    y2: "100%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7CEE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C3DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED1E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "34.653%",
    x2: "17.936%",
    y2: "80.29%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558FAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EC2D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.797%",
    y1: "61.326%",
    x2: "7.133%",
    y2: "29.679%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6699B6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.167%",
    y1: "61.326%",
    x2: "10.494%",
    y2: "29.679%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D97",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "51.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.217,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-20.929%",
    y2: "65.589%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#538EB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1D7E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.248%",
    y1: "37.471%",
    x2: "0%",
    y2: "70.925%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E6EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.333%",
    y1: "12.618%",
    x2: ".982%",
    y2: "100%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5E6",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.445%",
    y1: "-7.875%",
    x2: "10.555%",
    y2: "100%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7CEE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C3DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED1E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "34.421%",
    x2: "17.936%",
    y2: "80.748%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558FAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EC2D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.744%",
    y1: "61.326%",
    x2: "9.305%",
    y2: "29.679%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6699B6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.637%",
    y1: "61.326%",
    x2: "9.524%",
    y2: "29.679%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D97",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "51.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.217,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.881%",
    y1: "100%",
    x2: "185.289%",
    y2: "-84.031%",
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDAE7",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF0C6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.306%",
    y1: "100%",
    x2: "89.857%",
    y2: "-13.701%",
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDAE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF0C6",
    stopOpacity: 0.372,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h204v183H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.307 199.646 52.68 19.885c32.564 12.292 69.322 3.963 93.406-21.167 30.295-31.609 29.23-81.792-2.38-112.087a79.274 79.274 0 0 0-30.992-18.365c-26.33-8.31-59.33-8.691-98.998-1.143-98.382 18.72-114.966 53.629-49.752 104.723l36.036 28.154z",
    fill: "url(#c)",
    transform: "rotate(142 157.892 105.097)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m0 14.288 26.21 7.263v-7.263L0 7.026z",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.21 21.551v-7.263L52 7.026v7.262l-25.79 7.263z",
    fill: "url(#e)",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1.49 14.684v20.47L26.21 42V21.551z",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m26.21 42 24.799-6.669V14.288l-24.8 7.263z",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M0 7.026 26.21 0v14.288z",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M26.21 0v14.288L52 7.026z",
    transform: "rotate(21 -209.995 368.851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.799 28.42-21.26 6.2a1.4 1.4 0 0 0-1.007 1.344v15.72l-2.733 1.239V32.71l25-6.788v2.496z",
    fill: "url(#j)",
    opacity: 0.593,
    transform: "rotate(21 -177.222 367.669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.799 19.599-19.756 6.013a1.4 1.4 0 0 0-.992 1.34v15.965l-3.252 1.006V23.71l24-6.788v2.676z",
    fill: "url(#k)",
    transform: "scale(-1 1) rotate(-21 217.52 454.703)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.287 134.925-.7 1.824a.7.7 0 0 0 .592.948l3.73.329a.7.7 0 0 0 .715-.446l.746-1.944a.7.7 0 0 0-.615-.95l-3.776-.209a.7.7 0 0 0-.692.448zM134.287 139.925l-.7 1.824a.7.7 0 0 0 .592.948l3.73.329a.7.7 0 0 0 .715-.446l.746-1.944a.7.7 0 0 0-.615-.95l-3.776-.209a.7.7 0 0 0-.692.448z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#l)",
    strokeWidth: 0.5,
    d: "m33.799 21.923-10 26",
    transform: "translate(103.185 99.754)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m0 26.48 48.21 13.46V26.48L0 13.02z",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.21 39.94V26.48l47.439-13.46v13.46l-47.44 13.46z",
    fill: "url(#n)",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M2.742 27.213v37.936L48.21 77.837V39.94z",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m48.21 77.837 45.615-12.36V26.48L48.21 39.94z",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M0 13.02 48.21 0v26.48z",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M48.21 0v26.48l47.439-13.46z",
    transform: "rotate(-26 181.334 -37.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68 37.335 70.869 48.993a2.6 2.6 0 0 0-1.852 2.487l-.03 29.497-4.992 2.326.04-37.878 45.651-12.768-.004 4.678z",
    fill: "url(#s)",
    opacity: 0.593,
    transform: "rotate(-26 177.365 -.823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.664 57.729-37.46 11.236a2.6 2.6 0 0 0-1.852 2.494l.03 29.927-6.161 1.879-.04-37.878L68.66 52.713l.005 5.016z",
    fill: "url(#t)",
    transform: "scale(-1 1) rotate(26 -90.526 -179.726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.869 95.44 1.536 3.158a1.3 1.3 0 0 0 2.04.397l5.026-4.531a1.3 1.3 0 0 0 .299-1.535l-1.638-3.367a1.3 1.3 0 0 0-2.07-.368l-4.926 4.74a1.3 1.3 0 0 0-.267 1.506zM110.427 104.81l1.536 3.158a1.3 1.3 0 0 0 2.04.397l5.026-4.531a1.3 1.3 0 0 0 .299-1.534l-1.638-3.368a1.3 1.3 0 0 0-2.07-.368l-4.926 4.741a1.3 1.3 0 0 0-.267 1.505z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#u)",
    strokeWidth: 0.65,
    d: "m54.953 44.596 22.454 46.159",
    transform: "translate(34.939 33.733)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    opacity: 0.277,
    d: "m154.264 126.901-36.471 32.893 5.634 11.349 36.737-32.144z",
    transform: "translate(-27.648 -81.466)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    opacity: 0.277,
    d: "m158.86 140.403-36.067 32.391 17.202 33.16 35.626-31.105z",
    transform: "translate(-27.648 -81.466)"
  })))));
};
export default SvgEmptyBasket;